export default __webpack_public_path__ + "static/media/person-1.eeda782a.webp";